import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {trigger, state, style, transition, animate} from '@angular/animations';
import {Store} from '@ngrx/store';
import { faAngleLeft, faBookmark as bookmarkIcon } from '@fortawesome/pro-regular-svg-icons';
import { faCartShoppingFast, faConveyorBeltAlt } from '@fortawesome/pro-solid-svg-icons';
import {combineLatest, Subscription} from 'rxjs';
import {showSidebarBookmark} from 'user/actions/user-profile.actions';
import {
  BookmarksSearchFacets,
  BookmarksSearchType,
  ListItem, ListItemEntity, ListWithItemsCount,
  SearchAvailabilityFilter, StepDisplayedEnum,
} from '../../../../list/models/list';
import {ListSearchService} from '../../../../list/services/list-search.service';
import {
  BookmarkSearch
} from '../../../../list/components/searchable-bookmarks-search-bar/searchable-bookmarks-search-bar.component';
import {moveBookmarks, openList, setAvailableListPending} from '../../../../list/actions/list.actions';
import {tryToBulkHoldSelectedItems} from '../../../../bulk-select/actions/bulk-select.actions';

import {SitePermissions} from '../../../../permissions/models/permissions';
import {BulkFeatureKey} from '../../../../bulk-select/enums/bulk-feature-key';
import {CustomerFeature} from '../../../../customer-integration/customer-integration';
import {isAuthorizedInKeycloak, isStaffAuthorizedInKeycloak} from '../../../../keycloak/reducers/keycloak.reducer';
import {getLists, selectBookmarksAvailableListPending} from '../../../../list/reducers/list.reducer';
import {getSidebarBookmark} from 'user/reducers/user.reducer';

@Component({
  selector: 'app-ap-bookmark-sidebar',
  templateUrl: './ap-bookmark-sidebar.component.html',
  styleUrls: ['./ap-bookmark-sidebar.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({transform: 'translateX(0%)', opacity: 1, zIndex: 30})),
      state('out', style({transform: 'translateX(100%)', opacity: 0, zIndex: 0})),
      transition('out => in', [
        style({transform: 'translateX(100%)', opacity: 0}),
        animate('300ms ease-out')
      ]),
      transition('in => out', [
        animate('300ms ease-in', style({transform: 'translateX(100%)', opacity: 0}))
      ])
    ])
  ]
})
export class ApBookmarkSidebarComponent implements OnInit, OnDestroy {
  @Input() public show: boolean;
  public itemsEntitySelected: ListItemEntity[];
  public itemsSelectedCount: number = 0;
  public itemsSelectedCountSearch: number = 0;
  public isAllSelected: boolean = false;
  public isAllSelectedSearch: boolean = false;

  // icons
  public showcaseIcon = faConveyorBeltAlt;
  public readonly arrowIconLeft = faAngleLeft;
  public readonly bookmarkIcon = bookmarkIcon;

  // view data - search
  public items: ListItem[] = [];
  public itemsSearch: ListItem[] = [];
  public itemsDisplay: ListItem[] = [];
  public itemsSearchDisplay: ListItem[] = [];
  public loading: boolean = true;
  public latestSearch: BookmarkSearch;
  public isSearch = false;
  public availableCountSearch: number;
  public page: number = 0;

  // constants
  public sitePermissions = SitePermissions;
  public readonly bulkFeatureKey = BulkFeatureKey.BOOKMARKS;
  public readonly CustomerFeature = CustomerFeature;
  public availabilityFilter: SearchAvailabilityFilter = SearchAvailabilityFilter.Available;

  public lists: ListWithItemsCount[] = [];
  public emptyLists: ListWithItemsCount[] = [];
  public stepDisplayed: StepDisplayedEnum = StepDisplayedEnum.lists;
  public listOpenCloseState = false;
  public authorized: boolean;
  public isStaffAuthorized: boolean;
  public facets: BookmarksSearchFacets;
  public count: number;
  public availableCount: number;

  public readonly stepDisplayedEnum = StepDisplayedEnum;
  private readonly subscriptions: Subscription = new Subscription();


  constructor(
    public store: Store,
    private readonly listSearchService: ListSearchService,
    public cdRef: ChangeDetectorRef
  ) {
  }

  public ngOnInit() {

    this.subscriptions.add(this.store.select(getLists).subscribe((lists) => {
      if (lists.length) {
        this.lists = JSON.parse(JSON.stringify(lists));

        const emptyLists = (
          JSON.parse(JSON.stringify(lists)) as ListWithItemsCount[]
        ).map((l) => ({ ...l, items: [] }));
        emptyLists.sort(this.orderLists);
        this.emptyLists = emptyLists;
        const availableSearch = {
          text: '',
          availableOnly: false,
          type: BookmarksSearchType.Author,
        };

        this.listSearchService
          .searchAll(availableSearch, true)
          .subscribe(({ initialCount, initialAvailableCount }) => {
            this.count = initialCount;
            this.availableCount = initialAvailableCount;
            this.cdRef.detectChanges();
          });
      }
    }));

    this.subscriptions.add(this.store.select(selectBookmarksAvailableListPending).subscribe((isPending) => {
      if (isPending) {
        setTimeout(() => this.openAvailableList());
      }
      this.store.dispatch(setAvailableListPending({isPending: false}));
    }));
  }

  public async onSearch(search: BookmarkSearch, initial = false) {
    this.page = 0;
    if (search.text || initial) {
      this.isSearch = true;
      this.isAllSelectedSearch = false;
    } else {
      this.isSearch = false;
      this.isAllSelected = false;
      this.loading = false;
      return;
    }
    this.loading = true;
    this.listSearchService.searchAll(search, true).subscribe(({available}) => {
      this.items = available;
      this.itemsSearch = this.items.filter(i => i.matched);
      this.itemsDisplay = this.items.slice(this.page, this.page + 100);
      this.itemsSearchDisplay = this.itemsSearch.slice(this.page, this.page + 100);
      this.page++;
      this.updateSelected();
      this.loading = false;
    });
  }
  //
  // public loadMoreItems() {
  //   const start = this.page * 100;
  //   this.itemsDisplay.push(...this.items.slice(start, start + 100));
  //   this.itemsSearchDisplay.push(...this.itemsSearch.slice(start, start + 100));
  //   this.page++;
  // }
  //
  // public setAllItemsSelection(listId: string, selected: boolean): void {
  //   this.isAllSelected = selected;
  //   this.items.forEach(item => item.selected = this.isAllSelected);
  //   this.updateSelected();
  // }
  //
  // public setAllItemsSelectionSearch(listId: string, selected: boolean): void {
  //   this.isAllSelectedSearch = selected;
  //   this.itemsSearch.forEach(item => {
  //     if (item.matched) {
  //       item.selected = this.isAllSelectedSearch;
  //     }
  //   });
  //   this.updateSelected();
  // }

  public updateSelected() {
    this.itemsEntitySelected = this.items.filter((item) => item.selected).map((item) => item.entity);
    this.itemsSelectedCount = this.itemsEntitySelected.length;
    const selectedMatches = this.itemsSearch.filter((item) => item.matched && item.selected);
    this.itemsSelectedCountSearch = selectedMatches.length;
    this.availableCount = this.items.length;
    this.availableCountSearch = this.itemsSearch.length;
  }

  // public onToggleItem(listId: string, listItem: ListItem): void {
  //   const item = this.items.find(item => item.id === listItem.id);
  //   if (item) {
  //     item.selected = !item.selected;
  //   }
  //   this.updateSelected();
  // }

  public removeSelectedFromList(): void {
    const items = this.itemsEntitySelected.map((item) => item);
    this.store.dispatch(moveBookmarks({entities: items, fromListIds: ['available-list']}));
  }

  // public bulkPlaceHolds(event: Event) {
  //   event.stopPropagation();
  //   if (this.itemsEntitySelected.length) {
  //     const items = this.itemsEntitySelected.map((item) => item.sourceEntity);
  //     this.store.dispatch(tryToBulkHoldSelectedItems({bulkFeatureKey: this.bulkFeatureKey, items}));
  //   }
  // }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public onDismissActiveModal() {
    this.store.dispatch(showSidebarBookmark({sidebarBookmark: false}));
    this.cdRef.detectChanges();
  }

  // public openList(list: ListWithItemsCount) {
  //   this.stepDisplayed = this.stepDisplayedEnum.singleList;
  //   this.listOpenCloseState = true;
  //   this.store.dispatch(openList({ listId: list.id }));
  // }

  public openAvailableList() {
    this.stepDisplayed = this.stepDisplayedEnum.availableList;
    this.listOpenCloseState = true;
  }

  private orderLists(a: ListWithItemsCount, b: ListWithItemsCount) {
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
      return -1;
    } else if (a.name.toLowerCase() > b.name.toLowerCase()) {
      return 1;
    }
    return 0;
  }
}
